import 'uno.css'
import { createApp } from 'vue'

import '@unocss/reset/tailwind-compat.css'
import '@mp/styles/var.css'
import '@mp/styles/element-reset.css'
import '@mp/api/typings'

import SpTrack from '@sp/track'

import { VueQueryPlugin } from '@tanstack/vue-query'

import '@sp/pc-ui/es/style.css'

import router from '@/router'

// @ts-ignore 忽略类型检查以解决模块导入问题
import App from './App.vue'

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import relativeTime from 'dayjs/plugin/relativeTime'
import { setupSentry } from '@/utils/sentry'

dayjs.locale('zh-cn')
dayjs.extend(relativeTime)

async function bootstrap() {
  const app = createApp(App)

  app.use(router)
  app.use(VueQueryPlugin)
  app.use(SpTrack)

  setupSentry(app, router)

  app.mount('#app')
}

bootstrap()
